import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import { IResponseInfo } from '../http/http.data';
import {
  FEEDBACK_ACCEPT_VERSION,
  FEEDBACK_ACCEPT_VERSION_200,
  FeedbackScreenEnum,
} from './feedback-data.data';
import { IFeedback, IFeedback200 } from './feedback-data.actions';

@Injectable()
export class FeedbackDataService {
  protected inputHeaders: any = {
    [ACCEPT_VERSION_HEADER]: FEEDBACK_ACCEPT_VERSION,
  };

  protected inputHeaders200: any = {
    [ACCEPT_VERSION_HEADER]: FEEDBACK_ACCEPT_VERSION_200,
  };

  feedbackUrl = '/feedback';

  constructor(private _authHttpService: AuthHttpService) {}

  fetchScreen(screenId: FeedbackScreenEnum): Observable<IResponseInfo> {
    return this._authHttpService.get(
      `${this.feedbackUrl}/public/screens/${screenId}`
    );
  }

  sendFeedback200({
    screen,
    screenProperties,
    comment,
    userEmail,
  }: IFeedback200): Observable<IResponseInfo> {
    return this._authHttpService.post(
      this.feedbackUrl,
      {
        screen_id: screen,
        email: userEmail,
        screen_properties: screenProperties,
        comment,
      },
      this.inputHeaders200
    );
  }

  sendFeedback({
    screen,
    screenProperties,
    feedback,
  }: IFeedback): Observable<IResponseInfo> {
    return this._authHttpService.post(
      this.feedbackUrl,
      {
        screen_id: screen,
        screen_properties: screenProperties,
        feedback,
      },
      this.inputHeaders
    );
  }
}
